import shortid from 'shortid';

import {
    SET_DATA,
    LOADING_ON,
    LOADING_OFF,
    SET_USER,
    SET_APP_MODE,
    SET_APP_MODE_DATA,
    CLEAR_APP_MODE_DATA,
    SET_APP_SUBMODE,
    SET_MENU_CHANGED,
    SET_RECIPE_CHANGED,
    LOAD_GLOBALS,
    MERGE_GLOBALS,
    SET_GLOBAL,
    SHOW_MESSAGE,
    SET_LECTURETASK_DATA,
    SET_LECTURETASK_COMPLETE,
    SET_LECTURETASK_COMPLETE_SAVED,
    SET_PROFILE_DATA,
    SET_PROFILE_ID,
    RESET_RECIPE,
    ADD_ACTIVITY,
    UPDATE_ACTIVITY,
    REMOVE_ACTIVITY,
    ADD_FOOD_GROUP,
    SET_FOOD_GROUP_TITLE,
    SET_FOOD_GROUP_DESCRIPTION,
    DELETE_EMPTY_FOOD_GROUPS,
    CHANGE_FOOD_GROUP_TYPE,
    OPEN_FOOD_GROUP,
    CLOSE_FOOD_GROUP,
    MOVE_FOOD_GROUP,
    REMOVE_FOOD_GROUP,
    MODIFY_FOOD_GROUP_AMOUNTS,
    MOVE_FOODS_TO_GROUP,
    ADD_FOOD,
    REMOVE_FOOD,
    SORT_FOOD,
    MOVE_FOOD_TO_PLATE,
    SET_FOOD_AMOUNT,
    SET_FOOD_AS_DRINK,
    ADD_FOOD_MODIFICATION,
    REMOVE_FOOD_MODIFICATION,
    ASSIGN_STATE,
    LOAD_DAYPLAN,
    SET_PLANNER_EDIT_MODE,
    SET_ACTIVE_MEAL_HASH,
    SET_PLANNER_DATE,
    SET_EVALUATION_RESULTS,
    CLEAR_EVALUATION_RESULTS,
    SET_DAY_EVALUATION_RESULTS,
    SET_DAY_EVALUATION_RESULTS_NK,
    OPEN_MODAL,
    CLOSE_MODAL,
    SET_LAST_SAVED_AT,
    SET_MODAL_CONTENT,
    SET_RECIPE_TITLE,
    CLEAR_MEAL,
    ADD_MEAL,
    REMOVE_MEAL,
    UPDATE_MEAL,
    SET_MEAL_DESCRIPTION,
    ADD_TAG,
    REMOVE_TAG,
    SET_TAGS,
    SET_TRAINING,
    ADD_TRAINING,
    UPDATE_TRAINING,
    REMOVE_TRAINING,
    SET_TRAINING_START,
    SET_TRAINING_LENGTH,
    SET_TRAINING_DESCRIPTION,
    SET_DAY_ENERGY_OUTPUT_COEFFICIENT,
    SET_DAY_ENERGY_OUTPUT_AMOUNT,
    SET_DAY_ENERGY_OUTPUT_AMOUNT_UNIT,
    SET_PLANNER_VIEW_MODE,
} from "../actions/index";

import {
    handleLoadDayPlan,
    handleAddMeal,
    handleRemoveMeal,
    handleUpdateMeal,
    handleClearMeal,
    handleSetMealDescription,
} from './mealHandlers';

import {
    saveCurrentRecipeToLocalStorage,
    handleSetRecipeTitle,
    handleAddFoodGroup,
    handleSetFoodGroupTitle,
    handleSetFoodGroupDescription,
    handleDeleteEmptyFoodGroups,
    handleChangeFoodGroupType,
    handleOpenFoodGroup,
    handleCloseFoodGroup,
    handleMoveFoodGroup,
    handleRemoveFoodGroup,
    handleModifyFoodGroupAmounts,
    handleMoveFoodsToGroup,
    handleAddFood,
    handleRemoveFood,
    handleSortFood,
    handleMoveFoodToPlate,
    handleSetFoodAmount,
    handleSetFoodAsDrink,
    handleAddFoodModification,
    handleRemoveFoodModification,
} from './recipeHandlers';

import {
    handleSetTraining,
    handleAddTraining,
    handleUpdateTraining,
    handleSetTrainingStart,
    handleSetTrainingLength,
    handleSetTrainingDescription,
    handleRemoveTraining,
} from './trainingHandlers';


const initialState = {

    // Basic (common) data

    globals: {},                    // Global app data (helpers, dictionaries, lists etc.) Loaded from API on start

    menuChanged: false,
    recipeChanged: false,

    appMode: 'LECTURE',             // App mode
    appSubMode: '',                 // for LECTURE appMode: empty or "LECTURETASK_SAMPLE" for sample lecture task mode (NO SAVING)
    appModeData: {},                // App mode data (depends on current mode)
    lectureTaskData: {},            // If lecture task mode, holds the lecture task data
    lectureTaskComplete: false,     // Is lecture task completed?
    lectureTaskCompleteSaved: false,// Is lecture task completed AND saved?

    user: false,                    // Logged in user's data
    profileId: 0,                   // ID of current user's active profile

    plannerDate: false,             // (Date) current selected date in planner
    plannerViewMode: 0,             // 0 = full (with empty hours), 1 = compact (without empty hours)
    plannerEditMode: '',            // '' = generic, 'GASTRO_DAILY_MENU' = daily menu (gastro)

    meals: {},                      // Meals in recipe
    foodGroups: {},                 // Food groups
    foods: {},                      // Foods
    modifications: {},              // Food modifications
    titles: {},                     // Food groups titles
    descriptions: {},               // Food groups descriptions
    trainings: {},                  // Trainings during day plan
    activities: {},                 // (not currently used)
    energyOutputSettings: {},       // Energy output settings for current day in planner
    evaluationResults: {},          // Current evaluation results combined from meals
    mealsEvaluationResults: {},     // Current evaluation results for individual meals
    evaluationResultsNk: false,     // Alternate evaluation results for NUTRIKUCHAR mode
    activeMealHash: '',             // Hash of currently active meal

    modalOpened: false,             // Modal - is opened?
    modalTitle: '',                 // Title of modal
    modalClass: '',                 // Additional classes of modal window
    modalContent: false,            // Content of modal (JSX)
    modalOnClose: false,            // Callback to call when modal closes

    unreadNews: 0,                  // Number of unread news for current user

    tags: {},                       // Current recipe tags

    profiClientId: 0,               // ID of client the app is "switched" to

    loading: true,                  // Is app loading? (showing spinner)

    lastSavedAt: 0,

    lastAddedRecipeTitle: '',

    message: {
        show: false,
        type: 'info',               // info / error / success
        message: ''
    },

};


function rootReducer(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch(action.type) {

        case SET_DATA:
            newState = Object.assign(newState, action.data);
            saveCurrentRecipeToLocalStorage(newState);
            return newState;

        case LOADING_ON:
            newState.loading = true;
            return newState;

        case LOADING_OFF:
            newState.loading = false;
            return newState;

        case SET_USER:
            newState.user = action.data;
            return newState;

        case SET_APP_MODE:
            newState.appMode = action.data;
            return newState;

        case SET_APP_MODE_DATA:
            Object.keys(action.data).map(k => {
                newState.appModeData[k] = action.data[k];
            });
            return newState;

        case CLEAR_APP_MODE_DATA:
            newState.appModeData = {};
            return newState;

        case SET_APP_SUBMODE:
            newState.appSubMode = action.data;
            return newState;

        case SET_LECTURETASK_DATA:
            newState.lectureTaskData = action.data;
            return newState;

        case SET_LECTURETASK_COMPLETE:
            newState.lectureTaskComplete = action.data;
            return newState;

        case SET_LECTURETASK_COMPLETE_SAVED:
            newState.lectureTaskCompleteSaved = action.data;
            return newState;

        case SET_MENU_CHANGED:
            newState.menuChanged = action.data;
            return newState;

        case SET_RECIPE_CHANGED:
            newState.recipeChanged = action.data;
            return newState;

        case LOAD_GLOBALS:
            newState.globals = action.data;
            return newState;

        case MERGE_GLOBALS:
            newState.globals = Object.assign(newState.globals, action.data);
            return newState;

        case SET_GLOBAL:
            newState.globals[action.data.key] = action.data.value;
            return newState;

        case SHOW_MESSAGE:
            newState.message = action.data;
            return newState;

        case RESET_RECIPE:
            const lastAppMode = newState.appMode;
            const lastAppModeData = newState.appModeData;
            const lastLectureTaskData = newState.lectureTaskData;
            newState.menuChanged = true;
            newState.recipeChanged = true;
            newState = Object.assign({}, initialState);
            newState.appMode = lastAppMode;
            newState.appModeData = lastAppModeData;
            newState.user = state.user;
            newState.globals = state.globals;
            newState.activeMealHash = '1|0';
            newState.tags = [];
            newState.meals = {};
            newState.foodGroups = {};
            newState.foods = {};
            newState.modifications = {};
            newState.titles = {};
            newState.descriptions = {};
            newState.trainings = {};
            newState.activities = {};
            newState.lectureTaskData = lastLectureTaskData;
            return newState;

        case ADD_ACTIVITY:
            newState.menuChanged = true;
            const actHash = action.data.activityId + '|' + action.data.profiles.sort((a, b) => a - b).join(',');
            newState.activities[action.data.id] = {
                hash: actHash,
                activityId: action.data.activityId,
                startHour: action.data.startHour,
                startMinute: action.data.startMinute,
                length: action.data.length,
                profiles: action.data.profiles
            };
            return newState;

        case UPDATE_ACTIVITY:
            newState.menuChanged = true;
            let newActivities = [];
            newState.activities.map(id => {
                if (newState.activities[id].id != action.data.id) newActivities.push(newState.activities[id]);
            });
            newState.activities.push({
                id: action.data.id,
                fromHour: action.data.fromHour,
                fromMinute: action.data.fromMinute,
                toHour: action.data.toHour,
                toMinute: action.data.toMinute
            });
            return newState;

        case REMOVE_ACTIVITY:
            newState.menuChanged = true;
            let filteredActivities = [];
            newState.activities.map(act => {
                if (act.id != action.data) filteredActivities.push(act);
            });
            newState.activities = filteredActivities;
            return newState;

        case ASSIGN_STATE:
            newState = Object.assign(newState, action.data);
            return newState;

        case SET_PLANNER_EDIT_MODE:
            newState.plannerEditMode = action.data;
            return newState;

        case SET_ACTIVE_MEAL_HASH:
            newState.activeMealHash = action.data;
            return newState;

        case SET_PLANNER_DATE:
            newState.plannerDate = action.data;
            return newState;

        case SET_EVALUATION_RESULTS:
            newState.evaluationResults = action.data;
            return newState;

        case CLEAR_EVALUATION_RESULTS:
            newState.evaluationResults = {};
            newState.mealsEvaluationResults = {};
            newState.evaluationResultsNk = false;
            return newState;

        case SET_DAY_EVALUATION_RESULTS:
            newState.evaluationResults = action.data.results;
            newState.mealsEvaluationResults = action.data.mealsResults;
            return newState;

        case SET_DAY_EVALUATION_RESULTS_NK:
            newState.evaluationResultsNk = action.data;
            return newState;

        case OPEN_MODAL:
            newState.modalClass = '';
            if(typeof action.data.class !== 'undefined') newState.modalClass = action.data.class;
            newState.closeButton = '';
            if(typeof action.data.closeButton !== 'undefined') newState.closeButton = action.data.closeButton;
            newState.modalTitle = action.data.title;
            newState.modalContent = action.data.content;
            newState.modalOnClose = false;
            if(typeof action.data.onClose !== 'undefined') {
                newState.modalOnClose = action.data.onClose;
            }
            newState.modalOpened = true;
            return newState;

        case CLOSE_MODAL:
            newState.modalOpened = false;
            newState.modalOnClose = false;
            return newState;

        case SET_LAST_SAVED_AT:
            newState.lastSavedAt = action.data;
            return newState;

        case SET_MODAL_CONTENT:
            newState.modalContent = action.data;
            return newState;

        case ADD_TAG:
            newState.menuChanged = true;
            newState.recipeChanged = true;
            newState.tags[state.activeMealHash].push(action.data);
            return newState;

        case REMOVE_TAG:
            newState.menuChanged = true;
            newState.recipeChanged = true;
            newState.tags[state.activeMealHash].filter(tagId => tagId !== action.data);
            return newState;

        case SET_TAGS:
            newState.menuChanged = true;
            newState.recipeChanged = true;
            newState.tags[state.activeMealHash] = action.data;
            return newState;

        case SET_PROFILE_DATA:
            newState.globals.profiles[action.data.id] = action.data.data;
            return newState;

        case SET_PROFILE_ID:
            newState.profileId = action.data * 1;
            return newState;

        case SET_DAY_ENERGY_OUTPUT_COEFFICIENT:
            newState.menuChanged = true;
            if(typeof newState.energyOutputSettings[action.data.profileId] == 'undefined') {
                newState.energyOutputSettings[action.data.profileId] = {coefficientId: -1, amount: 0, unit: 'kcal'};
            }
            newState.energyOutputSettings[action.data.profileId].coefficientId = action.data.coefficientId * 1;
            newState.energyOutputSettings[action.data.profileId].amount = 0;
            return newState;

        case SET_DAY_ENERGY_OUTPUT_AMOUNT:
            newState.menuChanged = true;
            if (typeof newState.energyOutputSettings[action.data.profileId] == 'undefined') {
                newState.energyOutputSettings[action.data.profileId] = {coefficientId: -1, amount: 0, unit: 'kcal'};
            }
            newState.energyOutputSettings[action.data.profileId].amount = action.data.amount * 1;
            newState.energyOutputSettings[action.data.profileId].coefficientId = -1;
            return newState;

        case SET_DAY_ENERGY_OUTPUT_AMOUNT_UNIT:
            newState.menuChanged = true;
            if (typeof newState.energyOutputSettings[action.data.profileId] == 'undefined') {
                newState.energyOutputSettings[action.data.profileId] = {coefficientId: -1, amount: 0, unit: 'kcal'};
            }
            newState.energyOutputSettings[action.data.profileId].unit = action.data.unit;
            newState.energyOutputSettings[action.data.profileId].coefficientId = -1;
            return newState;

        case SET_PLANNER_VIEW_MODE:
            newState.plannerViewMode = action.data;
            return newState;

        // --- Meal handlers ---

        case LOAD_DAYPLAN:          return handleLoadDayPlan(state, action);
        case ADD_MEAL:              return handleAddMeal(state, action);
        case REMOVE_MEAL:           return handleRemoveMeal(state, action);
        case UPDATE_MEAL:           return handleUpdateMeal(state, action);
        case CLEAR_MEAL:            return handleClearMeal(state, action);
        case SET_MEAL_DESCRIPTION:  return handleSetMealDescription(state, action);

        // --- Recipe / food handlers ---

        case SET_RECIPE_TITLE:          return handleSetRecipeTitle(state, action);
        case ADD_FOOD_GROUP:            return handleAddFoodGroup(state, action);
        case SET_FOOD_GROUP_TITLE:      return handleSetFoodGroupTitle(state, action);
        case SET_FOOD_GROUP_DESCRIPTION:return handleSetFoodGroupDescription(state, action);
        case DELETE_EMPTY_FOOD_GROUPS:  return handleDeleteEmptyFoodGroups(state, action);
        case CHANGE_FOOD_GROUP_TYPE:    return handleChangeFoodGroupType(state, action);
        case OPEN_FOOD_GROUP:           return handleOpenFoodGroup(state, action);
        case CLOSE_FOOD_GROUP:          return handleCloseFoodGroup(state, action);
        case MOVE_FOOD_GROUP:           return handleMoveFoodGroup(state, action);
        case REMOVE_FOOD_GROUP:         return handleRemoveFoodGroup(state, action);
        case MODIFY_FOOD_GROUP_AMOUNTS: return handleModifyFoodGroupAmounts(state, action);
        case MOVE_FOODS_TO_GROUP:       return handleMoveFoodsToGroup(state, action);
        case ADD_FOOD:                  return handleAddFood(state, action);
        case REMOVE_FOOD:               return handleRemoveFood(state, action);
        case SORT_FOOD:                 return handleSortFood(state, action);
        case MOVE_FOOD_TO_PLATE:        return handleMoveFoodToPlate(state, action);
        case SET_FOOD_AMOUNT:           return handleSetFoodAmount(state, action);
        case SET_FOOD_AS_DRINK:         return handleSetFoodAsDrink(state, action);
        case ADD_FOOD_MODIFICATION:     return handleAddFoodModification(state, action);
        case REMOVE_FOOD_MODIFICATION:  return handleRemoveFoodModification(state, action);

        // --- Training handlers ---

        case SET_TRAINING:              return handleSetTraining(state, action);
        case ADD_TRAINING:              return handleAddTraining(state, action);
        case UPDATE_TRAINING:           return handleUpdateTraining(state, action);
        case SET_TRAINING_START:        return handleSetTrainingStart(state, action);
        case SET_TRAINING_LENGTH:       return handleSetTrainingLength(state, action);
        case SET_TRAINING_DESCRIPTION:  return handleSetTrainingDescription(state, action);
        case REMOVE_TRAINING:           return handleRemoveTraining(state, action);

        default:
            return newState;
    }
}

export default rootReducer;
